import React, {
    Fragment,
    useState,
    useEffect,
    useCallback,
    useMemo,
    useRef,
} from 'react';
import {
    Row,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
} from 'reactstrap';
import Select from 'react-select';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import CreateReservation from './components/createReservation';
import classnames from 'classnames';
import ReservationKanbanBoard from './components/KanbanBoard/Kanban';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReservationList from './components/List/reservationList';
import ImportCSVModal from './components/List/ImportCSVModal'
import { useSelector } from 'react-redux';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import SendMessagePanel from './components/SendMessagingManually/SendMessagePanel'
import {
    gAPI_GuestMessagingReservation_ListByPage,
    gAPI_GuestMessagingReservation_ListByFilter,
    gAPI_GuestMessagingReservation_ListBySearch,
    API_Ingetration,
    API_RMS,
    gAPI_RMS
} from '../../../../../constants/APIs';
import moment from 'moment';

const validate = (...values) => values.find((v) => v !== undefined && v !== null && v !== '');
const isTrue = (value) => {
    if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
    }
    return Boolean(value);
};
const capitalizeWords = (str) => {
    if (!str) return '';
    return str
        .toString()
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const formatDate = (value) => {
    if (!value) return '-';
    const mDate = moment(value);
    if (!mDate.isValid()) return '-';
    return mDate.format('MMM D, YYYY');
};

const mapStatusToColumn = (status) => {
    const key = status ? status.toString().trim().toLowerCase() : '';
    switch (key) {
        case 'future reservation':
            return 'futureReservation';
        case 'arriving soon':
            return 'arrivingSoon';
        case 'arrived':
            return 'arrived';
        case 'departed':
            return 'departed';
        default:
            return 'futureReservation';
    }
};


const TABLE_PAGE_SIZE = 10;
const BACKEND_PAGE_SIZE = 50;
const PAGES_PER_CHUNK = Math.max(1, Math.floor(BACKEND_PAGE_SIZE / TABLE_PAGE_SIZE));
const STATUS_FILTER_OPTIONS = [
    { label: 'Future reservations', value: 'futurereservations' },
    { label: 'Arriving soon', value: 'arrivingsoon' },
    { label: 'Arrived', value: 'checkedin' },
    { label: 'Departed', value: 'checkedout' },
];

const GuestMessagingReservations = () => {
    const [visible, setVisible] = useState(false);
    const [activeTab, setActiveTab] = useState('board');

    // Board-specific state
    const [boardReservations, setBoardReservations] = useState([]);
    const [boardIsLoading, setBoardIsLoading] = useState(false);
    const [boardStatusFilter, setBoardStatusFilter] = useState([]);
    const [boardPendingStatusFilter, setBoardPendingStatusFilter] = useState([]);
    const [boardSearchKeyword, setBoardSearchKeyword] = useState('');
    const [boardActiveSearchKeyword, setBoardActiveSearchKeyword] = useState('');

    // List-specific state
    const [listReservations, setListReservations] = useState([]);
    const [listIsLoading, setListIsLoading] = useState(false);
    const [chunkPage, setChunkPage] = useState(0);
    const [tablePage, setTablePage] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [listStatusFilter, setListStatusFilter] = useState([]);
    const [listPendingStatusFilter, setListPendingStatusFilter] = useState([]);
    const [listSearchKeyword, setListSearchKeyword] = useState('');
    const [listActiveSearchKeyword, setListActiveSearchKeyword] = useState('');

    const [showImportModal, setShowImportModal] = useState(false);
    const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
    const [showSendMessage, setShowSendMessage] = useState(false);
    const [activeMessageTab, setActiveMessageTab] = useState('sms');
    const [rmsCredentials, setRmsCredentials] = useState([]);
    const [rmsPropertyMap, setRmsPropertyMap] = useState({});
    const [rmsPropertyMapLoaded, setRmsPropertyMapLoaded] = useState(false);


    const chunkPageRef = useRef(0);
    const tablePageRef = useRef(0);
    const pendingTablePageRef = useRef(null);


    const { propertyId, groupId: storedGroupId, email: userEmail, userName } = useSelector(({ settings }) => ({
        propertyId: settings.propertyId,
        groupId: settings.groupId,
        email: settings.email,
        userName: settings.userName,
    }));
    const effectiveGroupId = storedGroupId || getGroupID();

    const styleCss = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
        top:auto !important;
        bottom: 0 !important;
      }
      .nav-tabs .nav-link {
        border: none;
      }
      .nav-tabs .nav-link.active,
      .nav-tabs .nav-link:hover {
        background-color: transparent;
      }`;

    const openSendMessagePanel = (tab = 'sms') => {
        setActiveMessageTab(tab);
        setShowSendMessage(true);
    };

    const closeSendMessagePanel = () => {
        setShowSendMessage(false);
    };


    const toggleModel = () => setVisible((prev) => !prev);
    const toggleImportModal = () => setShowImportModal((prev) => !prev);
    const handleDownloadTemplate = () => {
        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_TEMP_FILE_URL}`;
        link.download = 'reservation_template.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const toggleFilterPanel = () => {
        setIsFilterPanelOpen((prev) => {
            const next = !prev;
            if (!prev) {
                if (activeTab === 'board') {
                    setBoardPendingStatusFilter([...boardStatusFilter]);
                } else {
                    setListPendingStatusFilter([...listStatusFilter]);
                }
            }
            return next;
        });
    };

    const handleApplyStatusFilter = () => {
        if (activeTab === 'board') {
            setBoardStatusFilter([...boardPendingStatusFilter]);
        } else {
            setListStatusFilter([...listPendingStatusFilter]);
        }
        setIsFilterPanelOpen(false);
    };

    const handleClearStatusFilter = () => {
        if (activeTab === 'board') {
            setBoardPendingStatusFilter([]);
            setBoardStatusFilter([]);
        } else {
            setListPendingStatusFilter([]);
            setListStatusFilter([]);
        }
        setIsFilterPanelOpen(false);
    };

    useEffect(() => {
        chunkPageRef.current = chunkPage;
    }, [chunkPage]);

    useEffect(() => {
        tablePageRef.current = tablePage;
    }, [tablePage]);

    const resetPagination = useCallback(() => {
        pendingTablePageRef.current = 0;
        setChunkPage(0);
        setTablePage(0);
    }, []);

    /**
     * LIST TAB: paginated fetch (no search)
     */

    const fetchIntegrations = async () => {
        if (!propertyId) return [];
        const groupId = getGroupID();
        const channel = 'RMSBookingEngine';
        try {
            const res = await AxiosAPI({
                method: 'post',
                url: `${API_Ingetration}?group_id=${groupId}`,
                data: { Channels: [channel] },
            });

            const filtered = res.data.filter((item) => item.properties?.includes(propertyId));

            return filtered.map((i) => ({
                label: i.name,
                value: String(i.id),
            }));
        } catch (e) {
            console.error('PMS Integration error:', e);
            return [];
        }
    };
    const fetchRmsIntegrationDetail = async (integrationId) => {
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${API_RMS}/${integrationId}?group_id=${getGroupID()}`,
            });

            return {
                integrationId,
                clientId: res.data?.channelDetails?.clientId || null,
                clientSecret: res.data?.channelDetails?.clientSecret || null,
            };
        } catch (err) {
            console.error(`RMS fetch failed for id ${integrationId}`, err);
            return null;
        }
    };


    const fetchRmsClientDetails = async ({ clientId, clientSecret }) => {
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${gAPI_RMS}/client-details`,
                params: {
                    client_id: clientId,
                    client_secret: clientSecret,
                },
            });

            return res.data?.properties || [];
        } catch (err) {
            console.error('client-details failed', err);
            return [];
        }
    };

    const fetchAllRmsCredentials = async () => {
        const integrations = await fetchIntegrations();
        if (!integrations.length) return [];

        const promises = integrations.map((item) =>
            fetchRmsIntegrationDetail(item.value)
        );
        const results = await Promise.all(promises);


        return results.filter(
            (r) => r && r.clientId && r.clientSecret
        );
    };

    const fetchListReservations = useCallback(async (targetChunkPage) => {
        if (!propertyId || !effectiveGroupId) {
            setListReservations([]);
            setTotalItems(0);
            setChunkPage(0);
            setTablePage(0);
            return;
        }

        const chunkToLoad =
            typeof targetChunkPage === 'number'
                ? targetChunkPage
                : chunkPageRef.current || 0;

        setListIsLoading(true);
        try {
            const isFilterActive = listStatusFilter.length > 0;
            const requestConfig = isFilterActive
                ? {
                    method: 'get',
                    url: gAPI_GuestMessagingReservation_ListByFilter,
                    params: {
                        propertyId,
                        groupId: effectiveGroupId,
                        Status: listStatusFilter.map(s => s.value).join('|'),
                        pageNumber: chunkToLoad + 1,
                        pageSize: BACKEND_PAGE_SIZE,
                    },
                }
                : {
                    method: 'get',
                    url: `${gAPI_GuestMessagingReservation_ListByPage}/${propertyId}`,
                    params: {
                        groupId: effectiveGroupId,
                        pageNumber: chunkToLoad + 1,
                        pageSize: BACKEND_PAGE_SIZE,
                    },
                };
            const response = await AxiosAPI(requestConfig);
            const {
                reservation = [],
                totalPages = 0,
                totalItems = 0,
            } = response.data || {};
            setListReservations(Array.isArray(reservation) ? reservation : []);
            setChunkPage(chunkToLoad);
            setTotalItems(totalItems);

            const totalTablePages = totalItems > 0 ? Math.ceil(totalItems / TABLE_PAGE_SIZE) : 0;
            const chunkStartPage = chunkToLoad * PAGES_PER_CHUNK;
            const chunkEndPage = chunkStartPage + PAGES_PER_CHUNK - 1;
            let resolvedPage;

            if (pendingTablePageRef.current !== null) {
                resolvedPage = pendingTablePageRef.current;
                pendingTablePageRef.current = null;
            } else if (
                chunkToLoad === chunkPageRef.current &&
                tablePageRef.current >= chunkStartPage &&
                tablePageRef.current <= chunkEndPage
            ) {
                resolvedPage = tablePageRef.current;
            } else {
                resolvedPage = chunkStartPage;
            }

            if (totalTablePages > 0) {
                resolvedPage = Math.min(resolvedPage, totalTablePages - 1);
            } else {
                resolvedPage = 0;
            }

            setTablePage(Math.max(resolvedPage, chunkStartPage));
        } catch (err) {
            NotificationManager.error('Failed to load reservations', 'Error', 3000);
            setListReservations([]);
            setTotalItems(0);
        } finally {
            setListIsLoading(false);
        }
    }, [effectiveGroupId, listStatusFilter, propertyId]);

    /**
     * LIST TAB: paginated search
     */
    const fetchListSearchReservations = useCallback(
        async (targetChunkPage, overrideSearchTerm) => {
            if (!propertyId || !effectiveGroupId) {
                setListReservations([]);
                setTotalItems(0);
                setChunkPage(0);
                setTablePage(0);
                return;
            }

            const chunkToLoad =
                typeof targetChunkPage === 'number'
                    ? targetChunkPage
                    : chunkPageRef.current || 0;

            const searchValue =
                typeof overrideSearchTerm === 'string'
                    ? overrideSearchTerm.trim()
                    : listActiveSearchKeyword.trim();

            if (!searchValue) {
                setListActiveSearchKeyword('');
                await fetchListReservations(chunkToLoad);
                return;
            }

            setListIsLoading(true);
            try {
                const response = await AxiosAPI({
                    method: 'get',
                    url: gAPI_GuestMessagingReservation_ListBySearch,
                    params: {
                        propertyId,
                        groupId: effectiveGroupId,
                        search: searchValue,
                        pageNumber: chunkToLoad + 1,
                        pageSize: BACKEND_PAGE_SIZE,
                        ...(listStatusFilter.length > 0 ? { Status: listStatusFilter.map(s => s.value).join('|') } : {}),
                    },
                });
                const {
                    reservation = [],
                    totalPages = 0,
                    totalItems = 0,
                } = response.data || {};
                setListReservations(Array.isArray(reservation) ? reservation : []);
                setChunkPage(chunkToLoad);
                setTotalItems(totalItems);

                const totalTablePages = totalItems > 0 ? Math.ceil(totalItems / TABLE_PAGE_SIZE) : 0;
                const chunkStartPage = chunkToLoad * PAGES_PER_CHUNK;
                const chunkEndPage = chunkStartPage + PAGES_PER_CHUNK - 1;
                let resolvedPage;

                if (pendingTablePageRef.current !== null) {
                    resolvedPage = pendingTablePageRef.current;
                    pendingTablePageRef.current = null;
                } else if (
                    chunkToLoad === chunkPageRef.current &&
                    tablePageRef.current >= chunkStartPage &&
                    tablePageRef.current <= chunkEndPage
                ) {
                    resolvedPage = tablePageRef.current;
                } else {
                    resolvedPage = chunkStartPage;
                }

                if (totalTablePages > 0) {
                    resolvedPage = Math.min(resolvedPage, totalTablePages - 1);
                } else {
                    resolvedPage = 0;
                }

                setTablePage(Math.max(resolvedPage, chunkStartPage));
            } catch (err) {
                NotificationManager.error('Failed to search reservations', 'Error', 3000);
                setListReservations([]);
                setTotalItems(0);
            } finally {
                setListIsLoading(false);
            }
        },
        [effectiveGroupId, fetchListReservations, listActiveSearchKeyword, listStatusFilter, propertyId]
    );

    /**
     * BOARD TAB: unpaginated fetch (no search) – uses pageNumber = -1, pageSize = -1
     */
    const fetchBoardReservations = useCallback(async () => {
        if (!propertyId || !effectiveGroupId) {
            setBoardReservations([]);
            return;
        }

        setBoardIsLoading(true);
        try {
            const isFilterActive = boardStatusFilter.length > 0;
            const requestConfig = isFilterActive
                ? {
                    method: 'get',
                    url: gAPI_GuestMessagingReservation_ListByFilter,
                    params: {
                        propertyId,
                        groupId: effectiveGroupId,
                        Status: boardStatusFilter.map(s => s.value).join('|'),
                        pageNumber: -1,
                        pageSize: -1,
                    },
                }
                : {
                    method: 'get',
                    url: `${gAPI_GuestMessagingReservation_ListByPage}/${propertyId}`,
                    params: {
                        groupId: effectiveGroupId,
                        pageNumber: -1,
                        pageSize: -1,
                    },
                };

            const response = await AxiosAPI(requestConfig);
            const {
                reservation = [],
            } = response.data || {};
            setBoardReservations(Array.isArray(reservation) ? reservation : []);
        } catch (err) {
            NotificationManager.error('Failed to load reservations for board', 'Error', 3000);
            setBoardReservations([]);
        } finally {
            setBoardIsLoading(false);
        }
    }, [boardStatusFilter, effectiveGroupId, propertyId]);

    /**
     * BOARD TAB: unpaginated search – uses pageNumber = -1, pageSize = -1
     */
    const fetchBoardSearchReservations = useCallback(
        async (overrideSearchTerm) => {
            if (!propertyId || !effectiveGroupId) {
                setBoardReservations([]);
                return;
            }

            const searchValue =
                typeof overrideSearchTerm === 'string'
                    ? overrideSearchTerm.trim()
                    : boardActiveSearchKeyword.trim();

            if (!searchValue) {
                setBoardActiveSearchKeyword('');
                await fetchBoardReservations();
                return;
            }

            setBoardIsLoading(true);
            try {
                const response = await AxiosAPI({
                    method: 'get',
                    url: gAPI_GuestMessagingReservation_ListBySearch,
                    params: {
                        propertyId,
                        groupId: effectiveGroupId,
                        search: searchValue,
                        pageNumber: -1,
                        pageSize: -1,
                        ...(boardStatusFilter.length > 0
                            ? { Status: boardStatusFilter.map(s => s.value).join('|') }
                            : {}),
                    },
                });
                const {
                    reservation = [],
                } = response.data || {};
                setBoardReservations(Array.isArray(reservation) ? reservation : []);
            } catch (err) {
                NotificationManager.error('Failed to search reservations for board', 'Error', 3000);
                setBoardReservations([]);
            } finally {
                setBoardIsLoading(false);
            }
        },
        [boardActiveSearchKeyword, boardStatusFilter, effectiveGroupId, fetchBoardReservations, propertyId]
    );

    useEffect(() => {
        const loadRmsCredentials = async () => {
            const creds = await fetchAllRmsCredentials();
            setRmsCredentials(creds);
        };

        loadRmsCredentials();
    }, [propertyId]);

    useEffect(() => {
        const loadRmsPropertyMap = async () => {
            if (!rmsCredentials.length) {
                setRmsPropertyMapLoaded(true);
                return;
            }

            setRmsPropertyMapLoaded(false);

            try {
                const promises = rmsCredentials.map((cred) =>
                    fetchRmsClientDetails(cred)
                );
                const results = await Promise.all(promises);

                const map = {};
                results.flat().forEach((p) => {
                    if (p?.id && p?.name) {
                        map[String(p.id)] = p.name;
                    }
                });

                setRmsPropertyMap(map);
            } finally {
                setRmsPropertyMapLoaded(true);
            }
        };

        loadRmsPropertyMap();
    }, [rmsCredentials]);


    /**
     * Initial load + react to LIST search term changes
     */
    useEffect(() => {
        resetPagination();
        if (listActiveSearchKeyword) {
            fetchListSearchReservations(0);
        } else {
            fetchListReservations(0);
        }
    }, [fetchListReservations, fetchListSearchReservations, listActiveSearchKeyword, resetPagination]);

    /**
     * Initial load + react to BOARD search term changes
     */
    useEffect(() => {
        if (boardActiveSearchKeyword) {
            fetchBoardSearchReservations();
        } else {
            fetchBoardReservations();
        }
    }, [boardActiveSearchKeyword, fetchBoardReservations, fetchBoardSearchReservations]);

    const mapReservationRow = useCallback((item) => {
        const nameFirst = validate(item.NameFirst, item.nameFirst, item.firstName, '');
        const nameMiddle = validate(item.NameMiddle, item.nameMiddle, item.middleName, '');
        const nameLast = validate(item.NameLast, item.nameLast, item.lastName, '');
        const emailValue = validate(
            item.EmailAddress,
            item.Emailaddress,
            item.emailAddress,
            item.emailaddress,
            item.email,
            item.hasEmail ? 'available' : ''
        );
        const phoneValue = validate(
            item.PhoneMobile,
            item.Phonemobile,
            item.phoneMobile,
            item.phonemobile,
            item.phone,
            item.hasMobile ? 'available' : ''
        );
        const checkIn = validate(item.ArrivalDate, item.arrivalDate, item.checkInDate, '');
        const checkOut = validate(item.DepartureDate, item.departureDate, item.checkOutDate, '');
        const checkInDisplay = formatDate(checkIn);
        const checkOutDisplay = formatDate(checkOut);
        const dates =
            checkIn && checkOut
                ? `${checkInDisplay} – ${checkOutDisplay}`
                : checkIn
                    ? checkInDisplay
                    : checkOut
                        ? checkOutDisplay
                        : '-';
        const propertyCode = item.propertyCode?.toString().trim();
        const hasPropertyCode = Boolean(propertyCode);


        const rmsPropertyName =
            propertyCode && rmsPropertyMap[propertyCode]
                ? rmsPropertyMap[propertyCode]
                : '-';
        const isPropertyLoading =
            hasPropertyCode &&
            rmsCredentials.length > 0 &&
            !rmsPropertyMapLoaded;

        // const recentComms = validate(
        //     item.RecentComms,
        //     item.recentComms,
        //     item.RecentCommunication,
        //     item.recentCommunication,
        //     ''
        // );
        return {
            ...item,
            propertyName: rmsPropertyName,
            isPropertyLoading,
            hasPropertyCode,
            raw: item,
            displayName: [nameFirst, nameMiddle, nameLast].filter(Boolean).join(' ').trim(),
            referenceNumber:
                validate(
                    item.reference,
                    ''
                ) || '-',
            bookingSourceName:
                validate(
                    item.BookingSourceName,
                    item.bookingSourceName,
                    ''
                ) || '-',
            reservationStatusPms: validate(item.reservationStatusPms, item.ReservationStatusPms, '') || '-',
            datesRange: dates,
            email: emailValue || '',
            phone: phoneValue || '',
            hasEmail: Boolean(emailValue),
            hasPhone: Boolean(phoneValue),
            // recentComms: recentComms || '-',
            status: capitalizeWords(validate(item.Status, '')) || '-',
            kanbanStatus: mapStatusToColumn(validate(item.Status, '')),
            roomNumber: validate(item.RoomNumber, item.roomNumber, ''),
            roomTypeName: validate(item.RoomTypeName, item.roomTypeName, item.roomType, ''),
            checkInDisplay,
            checkOutDisplay,
        };
    }, [rmsPropertyMap, rmsCredentials, rmsPropertyMapLoaded]);
    const boardReservationRows = useMemo(
        () => boardReservations.map((item) => mapReservationRow(item)),
        [boardReservations, mapReservationRow]
    );

    const listReservationRows = useMemo(
        () => listReservations.map((item) => mapReservationRow(item)),
        [listReservations, mapReservationRow]
    );

    const handleSearchSubmit = useCallback(() => {
        if (activeTab === 'board') {
            const trimmed = boardSearchKeyword.trim();
            if (!trimmed) {
                if (boardActiveSearchKeyword) {
                    setBoardActiveSearchKeyword('');
                }
                return;
            }

            if (trimmed === boardActiveSearchKeyword) {
                if (boardActiveSearchKeyword) {
                    fetchBoardSearchReservations(trimmed);
                } else {
                    fetchBoardReservations();
                }
                return;
            }

            setBoardActiveSearchKeyword(trimmed);
        } else {
            const trimmed = listSearchKeyword.trim();
            if (!trimmed) {
                if (listActiveSearchKeyword) {
                    setListActiveSearchKeyword('');
                }
                return;
            }

            if (trimmed === listActiveSearchKeyword) {
                resetPagination();
                if (listActiveSearchKeyword) {
                    fetchListSearchReservations(0, trimmed);
                } else {
                    fetchListReservations(0);
                }
                return;
            }

            setListActiveSearchKeyword(trimmed);
        }
    }, [
        activeTab,
        boardActiveSearchKeyword,
        boardSearchKeyword,
        fetchBoardReservations,
        fetchBoardSearchReservations,
        fetchListReservations,
        fetchListSearchReservations,
        listActiveSearchKeyword,
        listSearchKeyword,
        resetPagination,
    ]);

    const handleSearchKeyDown = useCallback(
        (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                handleSearchSubmit();
            }
        },
        [handleSearchSubmit]
    );

    const handleClearSearch = useCallback(() => {
        if (activeTab === 'board') {
            if (!boardSearchKeyword && !boardActiveSearchKeyword) {
                return;
            }
            setBoardSearchKeyword('');
            setBoardActiveSearchKeyword('');
            fetchBoardReservations();
        } else {
            if (!listSearchKeyword && !listActiveSearchKeyword) {
                return;
            }
            setListSearchKeyword('');
            setListActiveSearchKeyword('');
            resetPagination();
            fetchListReservations(0);
        }
    }, [
        activeTab,
        boardActiveSearchKeyword,
        boardSearchKeyword,
        fetchBoardReservations,
        fetchListReservations,
        listActiveSearchKeyword,
        listSearchKeyword,
        resetPagination,
    ]);

    const chunkRelativePage = Math.max(0, tablePage - chunkPage * PAGES_PER_CHUNK);
    const currentPageRows = useMemo(() => {
        const start = chunkRelativePage * TABLE_PAGE_SIZE;
        return listReservationRows.slice(start, start + TABLE_PAGE_SIZE);
    }, [listReservationRows, chunkRelativePage]);

    const totalTablePages = totalItems > 0 ? Math.ceil(totalItems / TABLE_PAGE_SIZE) : 0;

    const handlePageChange = (nextPage) => {
        const targetChunk = Math.floor(nextPage / PAGES_PER_CHUNK);
        if (targetChunk !== chunkPage) {
            pendingTablePageRef.current = nextPage;
            if (listActiveSearchKeyword) {
                fetchListSearchReservations(targetChunk);
            } else {
                fetchListReservations(targetChunk);
            }
        } else {
            setTablePage(nextPage);
        }
    };

    const refreshCurrentChunk = useCallback(() => {
        pendingTablePageRef.current = tablePageRef.current;
        if (listActiveSearchKeyword) {
            fetchListSearchReservations(chunkPageRef.current);
        } else {
            fetchListReservations(chunkPageRef.current);
        }
        // Always keep board up-to-date as well
        if (boardActiveSearchKeyword) {
            fetchBoardSearchReservations();
        } else {
            fetchBoardReservations();
        }
    }, [
        boardActiveSearchKeyword,
        fetchBoardReservations,
        fetchBoardSearchReservations,
        fetchListReservations,
        fetchListSearchReservations,
        listActiveSearchKeyword,
    ]);

    return (
        <div className="dashboard-wrapper">
            <Row>
                <Colxx xxs="12" className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="flex-grow-1">
                            <Nav tabs className="card-header-tabs separator-tabs mb-0 ml-0 mr-0">
                                <style>{styleCss}</style>
                                <NavItem className="text-center" style={{ width: 'auto' }}>
                                    <NavLink
                                        to="#"
                                        style={{ background: 'none', cursor: 'pointer' }}
                                        className={classnames({
                                            active: activeTab === 'board',
                                            'nav-link': true,
                                        })}
                                        onClick={() => toggleTab('board')}
                                    >
                                        <span
                                            style={{
                                                color: activeTab === 'board' ? 'var(--theme-color-1)' : '#8f8f8f',
                                                fontWeight: 600,
                                            }}
                                        >
                                            Board
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem className="text-center" style={{ width: 'auto' }}>
                                    <NavLink
                                        to="#"
                                        style={{ background: 'none', cursor: 'pointer' }}
                                        className={classnames({
                                            active: activeTab === 'list',
                                            'nav-link': true,
                                        })}
                                        onClick={() => toggleTab('list')}
                                    >
                                        <span
                                            style={{
                                                color: activeTab === 'list' ? 'var(--theme-color-1)' : '#8f8f8f',
                                                fontWeight: 600,
                                            }}
                                        >
                                            List
                                        </span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </div>


                    <Fragment>
                        <div className="top-left-button-container mt-3 mb-3 d-flex align-items-center">
                            <div className="position-relative mr-2">
                                <Button
                                    color="primary"
                                    size="xs"
                                    className="d-flex align-items-center"
                                    onClick={toggleFilterPanel}
                                >
                                    <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
                                    Filters
                                    <i
                                        className={`simple-icon-arrow-${isFilterPanelOpen ? 'up' : 'down'} ml-2`}
                                        style={{ fontSize: 10 }}
                                    />
                                </Button>
                                {isFilterPanelOpen && (
                                    <div
                                        className="reservation-filter-panel"
                                        style={{
                                            position: 'absolute',
                                            top: '110%',
                                            left: 0,
                                            width: 260,
                                            zIndex: 12,
                                            background: '#fff',
                                            borderRadius: 12,
                                            boxShadow: '0 10px 30px rgba(15, 34, 58, 0.15)',
                                            padding: '16px',
                                        }}
                                    >
                                        <div className="mb-3">
                                            <label className="text-small font-weight-semibold d-block mb-1">
                                                Reservation status
                                            </label>
                                            <Select
                                                isMulti
                                                className="react-select"
                                                classNamePrefix="react-select"
                                                name="status"
                                                placeholder="Select statuses"
                                                onChange={activeTab === 'board' ? setBoardPendingStatusFilter : setListPendingStatusFilter}
                                                options={STATUS_FILTER_OPTIONS}
                                                value={activeTab === 'board' ? boardPendingStatusFilter : listPendingStatusFilter}
                                                closeMenuOnSelect={true}
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end">
                                            <Button size="xs" color="secondary" onClick={handleClearStatusFilter}>
                                                Clear
                                            </Button>
                                            <Button size="xs" color="primary" className="ml-2" onClick={handleApplyStatusFilter}>
                                                Apply
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>


                            {/* LEFT BUTTONS */}
                            <Button
                                color="primary"
                                size="xs"
                                outline
                                className="top-left-button mr-1"
                                onClick={toggleModel}
                            >
                                + Add New Reservation
                            </Button>

                            <Button
                                color="primary"
                                size="xs"
                                outline
                                className="ml-2"
                                onClick={toggleImportModal}
                            >
                                + Import
                            </Button>

                            <Button
                                color="primary"
                                size="xs"
                                outline
                                className="ml-2"
                                onClick={handleDownloadTemplate}
                            >
                                Download Template
                            </Button>
                            <Button
                                color="primary"
                                size="xs"
                                outline
                                className="ml-2"
                                onClick={() => openSendMessagePanel('sms')}
                            >
                                Send Message
                            </Button>

                            {/* RIGHT SIDE SEARCH BOX */}
                            <div className="d-inline-flex align-items-center ml-auto">
                                <Input
                                    type="text"
                                    name="keyword"
                                    id="reservation-search"
                                    placeholder="Search"
                                    value={activeTab === 'board' ? boardSearchKeyword : listSearchKeyword}
                                    onChange={(e) =>
                                        activeTab === 'board'
                                            ? setBoardSearchKeyword(e.target.value)
                                            : setListSearchKeyword(e.target.value)
                                    }
                                    onKeyDown={handleSearchKeyDown}
                                    style={{ width: 200, borderRadius: 50 }}
                                />
                                <Button
                                    size="xs"
                                    color="primary"
                                    className="ml-2"
                                    onClick={handleSearchSubmit}
                                    style={{ padding: '6px' }}
                                >
                                    Search
                                </Button>
                                {(
                                    (activeTab === 'board'
                                        ? boardSearchKeyword || boardActiveSearchKeyword
                                        : listSearchKeyword || listActiveSearchKeyword)
                                ) && (
                                        <Button
                                            size="xs"
                                            color="secondary"
                                            className="ml-2"
                                            outline
                                            onClick={handleClearSearch}
                                        >
                                            Clear
                                        </Button>
                                    )}
                            </div>
                        </div>
                    </Fragment>


                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="board">
                            <ReservationKanbanBoard
                                data={boardReservationRows}
                                loading={boardIsLoading}
                                onRefresh={refreshCurrentChunk}

                            />

                        </TabPane>
                        <TabPane tabId="list">
                            <ReservationList
                                data={currentPageRows}
                                loading={listIsLoading}
                                onRefresh={refreshCurrentChunk}
                                page={tablePage}
                                pageSize={TABLE_PAGE_SIZE}
                                totalPages={totalTablePages}
                                totalItems={totalItems}
                                onPageChange={handlePageChange}
                                pagesPerChunk={PAGES_PER_CHUNK}
                            />
                        </TabPane>
                    </TabContent>
                </Colxx>
            </Row>
            <CreateReservation
                visible={visible}
                toggle={toggleModel}
                onSuccess={refreshCurrentChunk}
            />
            <ImportCSVModal
                visible={showImportModal}
                toggle={toggleImportModal}
                propertyId={propertyId}
                groupId={effectiveGroupId}
                userEmail={userEmail}
                onSuccess={refreshCurrentChunk}
                userName={userName}
            />

            {showSendMessage && (
                <SendMessagePanel
                    activeTab={activeMessageTab}
                    onClose={closeSendMessagePanel}
                    propertyId={propertyId}
                    showStatusFilter={true}
                    source="Bulk"
                />
            )}

        </div>
    );
};

export default GuestMessagingReservations;

